import { useCallback } from "react";
import { useUserAccountRole } from "@zapier/client";
import { useTranslations } from "@zapier/i18n";

import type { CreateBlockReason } from "../useConnectionCreateRules";

/** Role-aware copy explaining why a connection create is blocked. */
export function useCreateBlockCopy() {
  const t = useTranslations("connection-create-rules");
  const { isAdmin, isSuperAdmin, isAccountOwner } = useUserAccountRole();
  const canManage = isAdmin || isSuperAdmin || isAccountOwner;

  const getMessage = useCallback(
    (reason: CreateBlockReason) =>
      reason === "managed"
        ? t("managed.tooltip", { canManage: String(canManage) })
        : t("restricted.tooltip"),
    [canManage, t],
  );

  return { canManage, getMessage };
}
